import { render } from "./ActivateWorkshop.vue?vue&type=template&id=3d2898c3&scoped=true"
import script from "./ActivateWorkshop.vue?vue&type=script&lang=js"
export * from "./ActivateWorkshop.vue?vue&type=script&lang=js"

import "./ActivateWorkshop.vue?vue&type=style&index=0&id=3d2898c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2898c3"]])

export default __exports__